import store from '@/store';
import tencentChat from './tencentChat';
import { createDoApi } from '@/api/chat'
class ChatService {
    // 添加好友
    static async applyFriend(params, callback) {
        let that = this;
        createDoApi(params).then(res => {
            console.log(res);
            let info = res.data;

            // tencentChat.createMessage( 'C2C', 'text', info.to, {
            // 	description: info.payload,
            // });
            console.log(res.msg);
            // util.showToast(res.msg)
            callback(info);
        }).catch(err => {
            console.log(err);
            console.log(err);
            // util.showToast(err)
        })
    }

    /**
     * @name 发送消息前验证
     */
    static sendBeforeVerify(type, payload, relation, currentMsn = 0, source = "chat") {
        console.log(relation)
        console.log(currentMsn)
        console.log(source)
        switch (type) {
            case 'text':
                if (payload.text == '') throw '发送的内容不可以为空';
                break;
            case 'audio':
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                break;
        }
        if (relation.self_black == 1) {
            throw '你已将对方拉入黑名单，消息暂时无法发出。'
        } else if (relation.friend_black == 1) {
            throw '你已被对方拉入黑名单，消息无法发出。'
        }
        // if (relation.is_mutual === 0) {

        if (source != 'kefu') {
            if (relation.to_agree == 3 && relation.friend_id > 0) {
                throw '你已将对方删除，消息无法发出'
            } else if (relation.to_agree == 3 && relation.friend_id == 0) {
                throw '你已被对方删除，消息无法发出。'
            }
            if (relation.to_agree == 0 && currentMsn > 4) {
                throw '对方为非好友，无法发送信息';
            } else if (relation.to_agree == 2 && currentMsn > 4) {
                throw '非好友，只能发送五条信息';
            }
        }
        // }
    }
}

export default ChatService;